import { Button } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { StyledDialog } from "@/components/pieces/StyledDialog";

interface SubmitActionItemDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function SubmitActionItemDialog({
  open,
  onClose,
  onConfirm,
}: SubmitActionItemDialogProps) {
  return (
    <StyledDialog
      isOpen={open}
      lazy={true}
      title="Submit all action items"
      width="480px"
      onClose={() => {
        onClose();
      }}
    >
      <Box p={24}>
        <Box>
          Are you sure you want to submit all action items? This action cannot
          be undone.
        </Box>
        <Box mt={3}>
          <Button
            intent="primary"
            large={true}
            onClick={() => {
              onConfirm();
            }}
          >
            Submit
          </Button>
          <Button
            large={true}
            onClick={() => {
              onClose();
            }}
            style={{ marginLeft: 12 }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </StyledDialog>
  );
}
